import { cn } from "@workspace/ui/lib/utils";
import type { SVGProps } from "react";

export interface MagnusLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function MagnusLogo({ className, ...props }: MagnusLogoProps) {
  return (
    <svg
      aria-label="Magnus"
      className={cn("size-5", className)}
      fill="currentColor"
      viewBox="0 0 512 512"
      {...props}
    >
      <path d="M375.1 124.2h91.1v91.1h-91.1v-91.1zm91.1 180.5l-91.6-89.4v178.8h91.6v-89.4zm-91.6-88.9h-74.1v178.3h-91.6V215.8h-71.5v178.3H45.8V124.7l236.9-.5 92 91.6z" />
    </svg>
  );
}
